import { CloseOutlined, EditOutlined } from '@ant-design/icons'
import { useState } from 'react'
import { SummaryEdit } from './SummaryEdit';

export const Summary = (props: { postScheduled: any, onChange: any}) => {

    const [edit, setEdit] = useState(false);
    const [editVisible, setEditVisible] = useState(false);    

    const handleMouseEnter = () => {
        setEditVisible(true);
    };

    const handleMouseLeave = () => {
        setEditVisible(false);
    };
      
    return (
        <div  
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{backgroundColor: edit ? 'ivory' : editVisible ? 'ivory' : '', marginBottom: '10px', display:'flex', alignItems: 'center', padding:'5px 10px'}}>                    
            {
                !edit ?
                    <div style={{ margin:'10px'}}>
                        {props.postScheduled.post.summary}
                    </div>
                :                         
                    <SummaryEdit                     
                        onFinish={() => {setEdit(!edit); props.onChange()}}                                                       
                        postScheduledId={props.postScheduled.id}
                        summary={props.postScheduled.post.summary}
                    />                  
            }            
            <span style={{ textDecoration: "none", color: "#3C4043", cursor:'pointer', fontWeight: 500, marginLeft:'10px' }} onClick={() => setEdit(!edit)}>
                {(editVisible || edit) && (edit ? <CloseOutlined/> : <EditOutlined />)}
            </span>
        </div>
    )
}
